/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Context_UnknownInputs */



/**
* | output |
* | --- |
* | "The server does not report the context window. Enter it below." |
*
* @param {Private_Models_Hint_Context_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_context_unknown = /** @type {((inputs?: Private_Models_Hint_Context_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Context_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server meldet kein Kontextfenster. Tragen Sie es unten ein.")
	return /** @type {LocalizedString} */ ("The server does not report the context window. Enter it below.")
});